import { render, staticRenderFns } from "./EchartsFrequency.vue?vue&type=template&id=dfc27d18&scoped=true"
import script from "./EchartsFrequency.vue?vue&type=script&lang=js"
export * from "./EchartsFrequency.vue?vue&type=script&lang=js"
import style0 from "./EchartsFrequency.vue?vue&type=style&index=0&id=dfc27d18&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc27d18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfc27d18')) {
      api.createRecord('dfc27d18', component.options)
    } else {
      api.reload('dfc27d18', component.options)
    }
    module.hot.accept("./EchartsFrequency.vue?vue&type=template&id=dfc27d18&scoped=true", function () {
      api.rerender('dfc27d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dataBoard/components/EchartsFrequency.vue"
export default component.exports